import React from 'react';
import { PolicyModal } from '../components/SettingsModal';

// Página pública usada pela landing page. O conteúdo vem do mesmo componente
// exibido dentro das configurações para evitar versões diferentes dos Termos.
export default function Terms() {
  const returnToPublicSite = () => window.location.assign('https://blopboru.com/');
  return (
    <main className="min-h-screen bg-[#0d0916]">
      <PolicyModal type="terms" onClose={returnToPublicSite} />
    </main>
  );
}
